module.exports = __webpack_public_path__ + "img/1252430342.de24a255.jpg";